/**
 * providers/ninetailed/track-pages.tsx
 *
 * App Router page-view tracking. The SDK's automatic page tracking only works
 * with the Pages Router, so App Router needs a component that calls `page()` on
 * route changes. Keyed on `pathname` so it fires once per navigation.
 *
 * Consent is NOT gated here: the SDK's privacy plugin (see buildNinetailedOptions)
 * blocks the `page` event centrally until the visitor grants consent, so this can
 * always call `page()` and rely on the plugin to drop it pre-consent.
 *
 * This handles page views for ONGOING navigation only (keyed on `pathname`). The
 * one-off re-fire needed the moment consent is first granted mid-session is owned
 * by `NinetailedConsentBridge`, which fires `page()`/`identify()` AFTER the SDK's
 * async feature-enable settles (firing here on the consent flip would race that
 * enable and fetch a profile without personalization features).
 */

'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useNinetailed } from '@ninetailed/experience.js-next';

export function TrackPages() {
  const { page } = useNinetailed();
  const pathname = usePathname();

  useEffect(() => {
    page();
  }, [page, pathname]);

  return null;
}
